import React, { useCallback, useEffect, useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { Card, Col, Container, Row, FormFeedback, Input, Button, Form, Dropdown, DropdownItem, DropdownMenu, DropdownToggle, Spinner, Label, UncontrolledTooltip } from 'reactstrap';
import { createSelector } from "reselect";
import SimpleBar from "simplebar-react";
import { country } from "common/data";
import pkFlag from "../../../assets/images/flags/pk.svg";
import AuthSlider from '../authCarousel';

//formik
import { useFormik } from 'formik';
import * as Yup from 'yup';
import { useDispatch } from 'react-redux';
import { initializeRegisterFlow, savePhoneNumber } from 'slices/auth/register/thunk';
import { getCheckUsername } from 'helpers/backend_helper';
import { toast } from 'react-toastify';
import { checkUser, sendOtpCode } from 'live-slices/auth/register/thunk';
import { debounce } from 'lodash';
import infoIcon from "../../../assets/images/i.png"
const CoverSignUp = () => {
    document.title = "Register - Buypass";
    const [loader, setLoader] = useState<boolean>(false);
    const [dropdownOpen4, setDropdownOpen4] = useState<boolean>(false);
    const toggle4 = () => setDropdownOpen4((prevState) => prevState);
    const navigate = useNavigate();
    const dispatch: any = useDispatch();
    const [apiValidated, setApiValidated] = useState(false);
    const [selectedAccountType, setSelectedAccountType] = useState("personal");
    const [isVOTP, setIsVOTP] = useState(false);


    useEffect(() => {
        initializeRegisterFlow();
    }, [])

    function normalizePhoneNumber(countryCode: string, phoneNumber: string) {

        let cleanedNumber = phoneNumber.trim();

        if (cleanedNumber.startsWith('+')) {
            cleanedNumber = cleanedNumber.slice(1);
        }

        const countryCodeWithoutPlus = countryCode.replace('+', '');
        if (cleanedNumber.startsWith(countryCodeWithoutPlus)) {
            cleanedNumber = cleanedNumber.slice(countryCodeWithoutPlus.length);
        }

        if (cleanedNumber.startsWith('0')) {
            cleanedNumber = cleanedNumber.slice(1);
        }
        return countryCode + cleanedNumber;
    }


    const validation = useFormik({
        initialValues: {
            phoneNumber: '',
            seletedCountry3: {
                id: 240,
                flagImg: pkFlag,
                countryName: "Pakistan",
                countryCode: "+92"
            }
        },
        validationSchema: Yup.object({
            phoneNumber: Yup.string()
                .required('Please enter your phone number')
                .matches(/^\d+$/, 'Only numeric values are allowed')
                .min(9, 'Phone number must be at least 9 digits')
                .max(15, 'Phone number cannot exceed 15 digits'),
        }),
        onSubmit: async (values) => {
            if (loader || validation.errors.phoneNumber || !apiValidated) {
                return;
            }
            setLoader(true);
            const fullPhoneNumber = normalizePhoneNumber(values.seletedCountry3.countryCode, values.phoneNumber);

            try {
                const response = await dispatch(
                    sendOtpCode({ type: "sms", phoneNumber: fullPhoneNumber, email: "", isVOTP: isVOTP })
                ).unwrap();

                if (response?.isUserExist === true) {
                    toast.error("This number is already used", { autoClose: 1000 });
                } else {
                    navigate("/otp-verification", { state: { numberId: response._id, phoneNumber: fullPhoneNumber, isVOTP: isVOTP } });
                    savePhoneNumber(fullPhoneNumber);
                }
            } catch (error) {
                console.error("Error during user check:", error);
                toast.error("Something went wrong. Please try again.", { autoClose: 1000 });
            } finally {
                setLoader(false);
            }
        }
    });

    const validatePhoneNumber = async (phoneNumber: any) => {
        const fullPhoneNumber = `${validation.values.seletedCountry3.countryCode}${phoneNumber}`;

        try {
            const result = await dispatch(
                checkUser({ username: fullPhoneNumber })
            ).unwrap();

            if (result?.isUserExist) {
                validation.setFieldError('phoneNumber', 'This number is already used');
                setApiValidated(false);

            } else {
                setApiValidated(true);
            }
        } catch (error) {
            console.error('Error during phone number validation:', error);
            validation.setFieldError(
                'phoneNumber',
                'Unable to validate phone number. Please try again later.'
            );
            setLoader(false);
        }
    };

    const debounceValidatePhoneNumber = useCallback(
        debounce((phoneNumber) => {
            if (phoneNumber.length >= 9) {
                validatePhoneNumber(phoneNumber);
            }
        }, 300),
        []
    );


    const handlePhoneNumberChange = (e: any) => {
        let phoneNumber = e.target.value.trim();
        if (phoneNumber.startsWith('+92')) {
            phoneNumber = phoneNumber.slice(3);
        } else if (phoneNumber.startsWith('92')) {
            phoneNumber = phoneNumber.slice(2);
        }

        if (phoneNumber.startsWith('0')) {
            phoneNumber = phoneNumber.slice(1);
        }

        validation.setFieldValue("phoneNumber", phoneNumber);
        setApiValidated(false);
        debounceValidatePhoneNumber(phoneNumber);
    };

    const handleSignupType = (type: string) => {
        setSelectedAccountType(type);
        setIsVOTP(type === "business");
    };


    return (
        <React.Fragment>
            <div className="auth-page-wrapper auth-bg-cover py-5 d-flex justify-content-center align-items-center min-vh-100 mobileScrolHight auth-form">
                <div className="bg-overlay"></div>
                <div className=" auth-page-content overflow-hidden pt-lg-5">
                    <Container>
                        <Row>
                            <Col lg={12}>
                                <Card className=" Specific-Class-for-border cardHightDv overflow-hidden m-0">
                                    <Row className="justify-content-center g-0 h-100">
                                        <AuthSlider />

                                        <Col lg={6} >
                                            <div className='d-flex justify-content-center align-items-center h-100 w-100'>
                                                <div className=" p-lg-5 p-4 w-100">
                                                    <div className='otpHeading'>
                                                        <h1 >Sign up as a Buypass Seller</h1>
                                                        <p >Sign up in 2 steps</p>
                                                    </div>

                                                    <div className='mt-4 w-100'>
                                                        <Form onSubmit={(e) => {
                                                            e.preventDefault();
                                                            validation.handleSubmit();
                                                        }}>
                                                            <div className=" ">
                                                                <Dropdown className="input-group position-relative" isOpen={dropdownOpen4} toggle={toggle4}>
                                                                    <DropdownToggle as="button" className="btn position-absolute   arrow-none" style={{ background: "transparent", marginTop: "1px", border: "white", boxShadow: "none" }}>
                                                                        <div className="flagspan" style={{ position: "absolute", left: "10px", top: "12px", alignItems: "center", display: "flex" }}>
                                                                            <img src={validation.values.seletedCountry3.flagImg} style={{ marginBottom: "5px" }} alt="country flag" className="options-flagimg" height="20" />
                                                                            <span className="countrylist-codeno text-dark ms-1 " style={{ fontSize: "14px" }} >{validation.values.seletedCountry3.countryCode}</span>
                                                                        </div>
                                                                    </DropdownToggle>


                                                                    <div className=" formContainer "
                                                                        style={{ width: "100%" }}
                                                                    >
                                                                        <label className="form-label" htmlFor="email-input"><span className="text-danger me-1">*</span>Phone Number</label>
                                                                        <Input
                                                                            name="phoneNumber"
                                                                            className="form-control rounded-start leftPad "
                                                                            placeholder="300 1234567"
                                                                            data-testing-Id="numberInput_register"
                                                                            type="number"
                                                                            style={{ paddingLeft: "63px" }}
                                                                            onChange={handlePhoneNumberChange}
                                                                            onBlur={(e) => {
                                                                                validation.handleBlur(e);
                                                                                validatePhoneNumber(e.target.value);
                                                                            }}
                                                                            value={validation.values.phoneNumber}
                                                                            invalid={validation.touched.phoneNumber && validation.errors.phoneNumber ? true : false}
                                                                            maxLength={10}
                                                                        />

                                                                        {validation.touched.phoneNumber && validation.errors.phoneNumber && (
                                                                            <FormFeedback type="invalid">
                                                                                {validation.errors.phoneNumber}
                                                                            </FormFeedback>
                                                                        )}

                                                                    </div>
                                                                    <p style={{ fontSize: "14px", marginBottom: "10px" }}> Receive OTP code</p>
                                                                    <div className="selectDv mb-2">
                                                                        <div
                                                                            className={`cursor-pointer selectedDv ${selectedAccountType === "personal" ? "active" : ""}`}
                                                                            onClick={() => handleSignupType("personal")}
                                                                        >
                                                                            <div className="d-flex gap-2">
                                                                                <Input
                                                                                    className="form-check-input cursor-pointer"
                                                                                    type="radio"
                                                                                    name="accountType"
                                                                                    id="personalAccount"
                                                                                    data-testing-Id="seller_selectuser"
                                                                                    value="personal"
                                                                                    checked={selectedAccountType === "personal"}
                                                                                    readOnly // no need to trigger change here
                                                                                />
                                                                                <Label
                                                                                    className="form-check-label d-flex align-items-center"
                                                                                    htmlFor="personalAccount"
                                                                                >
                                                                                    via sms
                                                                                </Label>
                                                                            </div>
                                                                            <div>
                                                                                <span
                                                                                    style={{
                                                                                        marginLeft: "10px",
                                                                                        marginBottom: "5px",
                                                                                        cursor: "pointer",
                                                                                    }}
                                                                                    id="personal"
                                                                                    onClick={(e) => e.stopPropagation()} // Prevent icon click from triggering parent click
                                                                                >
                                                                                    <img src={infoIcon} alt="" height={14} width={14} />
                                                                                </span>
                                                                                <UncontrolledTooltip placement="top" target="personal">
                                                                                    You will receive an OTP code via SMS
                                                                                </UncontrolledTooltip>
                                                                            </div>
                                                                        </div>

                                                                        <div
                                                                            className={`cursor-pointer selectedDv ${selectedAccountType === "business" ? "active" : ""}`}
                                                                            onClick={() => handleSignupType("business")}
                                                                        >
                                                                            <div className="d-flex gap-2">
                                                                                <Input
                                                                                    className="form-check-input cursor-pointer"
                                                                                    type="radio"
                                                                                    name="accountType"
                                                                                    id="businessAccount"
                                                                                    data-testing-Id="otherPartner_selectuser"
                                                                                    value="business"
                                                                                    checked={selectedAccountType === "business"}
                                                                                    readOnly
                                                                                />
                                                                                <Label className="form-check-label" htmlFor="businessAccount">
                                                                                    via voice
                                                                                </Label>
                                                                            </div>
                                                                            <div>
                                                                                <span
                                                                                    style={{
                                                                                        marginLeft: "10px",
                                                                                        marginBottom: "5px",
                                                                                        cursor: "pointer",
                                                                                    }}
                                                                                    id="business"
                                                                                    onClick={(e) => e.stopPropagation()}
                                                                                >
                                                                                    <img src={infoIcon} alt="" height={14} width={14} />
                                                                                </span>
                                                                                <UncontrolledTooltip placement="top" target="business">
                                                                                    You will receive an OTP code via voice call
                                                                                </UncontrolledTooltip>
                                                                            </div>
                                                                        </div>
                                                                    </div>


                                                                    <DropdownMenu as="ul" className="list-unstyled w-100 dropdown-menu-list mb-0">
                                                                        <SimpleBar style={{ maxHeight: '220px' }} className="px-3">
                                                                            {(country || []).map((item, key) => (
                                                                                <DropdownItem
                                                                                    as="li"
                                                                                    key={key}
                                                                                    className="dropdown-item d-flex"
                                                                                >
                                                                                    <div className="flex-shrink-0 me-2">
                                                                                        <img src={item.flagImg} alt="country flag" className="options-flagimg" height="20" />
                                                                                    </div>
                                                                                    <div className="flex-grow-1">
                                                                                        <div className="d-flex">
                                                                                            <div className="country-name me-1">{item.countryName}</div>
                                                                                            <span className="countrylist-codeno text-muted">{item.countryCode}</span>
                                                                                        </div>
                                                                                    </div>
                                                                                </DropdownItem>
                                                                            ))}
                                                                        </SimpleBar>
                                                                    </DropdownMenu>
                                                                </Dropdown>



                                                                <div className="mt-4 otpButton">
                                                                    <Button
                                                                        color="secondary"
                                                                        disabled={loader || !!validation.errors.phoneNumber || !apiValidated}
                                                                        className=" w-100"
                                                                        type="submit"
                                                                        data-testing-Id="sendOtpButton_register"
                                                                    >
                                                                        {loader && <Spinner size="sm" className="me-2"> Loading... </Spinner>}
                                                                        Send OTP
                                                                    </Button>
                                                                </div>



                                                                <div className=' text-center mt-5 AccountDv'>
                                                                    <p>Already have an account?
                                                                        <Link to="/login" className="text-muted mt-2 " data-testing-Id="creatAccount_login "><span className='text-secondary ms-1'>Login</span></Link>
                                                                    </p>
                                                                </div>
                                                            </div>
                                                        </Form>
                                                    </div>


                                                </div>
                                            </div>
                                        </Col>
                                    </Row>
                                </Card>
                            </Col>

                        </Row>
                    </Container>
                </div>

                {/* <footer className="footer">
                    <Container>
                        <div className="row">
                            <div className="col-lg-12">
                                <div className="text-center">
                                    <p className="mb-0">{new Date().getFullYear()} Velzon. Crafted with <i className="mdi mdi-heart text-danger"></i> by Themesbrand</p>
                                </div>
                            </div>
                        </div>
                    </Container>
                </footer> */}
            </div>
        </React.Fragment>
    );
};

export default CoverSignUp;